import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WelletContext } from '../../../context/WelletContext';
import InputFormBorder from '../InputFormBorder/InputFormBorder';
import ModalPickerSelector from '../../ModalSelector/ModalPickerSelector';

const RPAndCitySelector = ({
  requiresRP,
  selectedRp,
  setSelectedRp,
  selectedCity,
  setSelectedCity,
  handleChange,
  errors,
  values,
}) => {
  const { t } = useTranslation();
  const welletContext = useContext(WelletContext);

  const [rps, setRps] = useState([]);

  const withoutRP = { value: '0', label: t('signUp.withOutRP') };

  const cityOptions = [
    { value: 935, label: 'Cancún' },
    { value: 2265, label: 'Ciudad de México' },
    { value: 7925, label: 'Isla Mujeres' },
    { value: 182189, label: 'Tulum' },
    { value: 9631, label: 'Los Cabos' },
  ];

  const getRP = async () => {
    try {
      const result = await welletContext.apis.tickets.get(`associates/GetRPs`);
      const formatted = result.data.map((item) => ({ value: item.id, label: item.name }));
      setRps([...formatted, withoutRP]);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getRP();
  }, []);

  const handleChangeRP = (selectedOption) => {
    handleChange({ target: { name: 'rp', value: selectedOption.value }, persist: () => {} });
    setSelectedRp(selectedOption);
  };

  const handleChangeCity = (selectedOption) => {
    handleChange({ target: { name: 'city', value: selectedOption.value }, persist: () => {} });
    setSelectedCity(selectedOption);
  };

  return (
    <>
      <div className={`field-border-container mt-4 ${errors.city ? 'error' : ''}`}>
        <div className='field-none-border p-0'>
          <div className='field-border-name' style={{ zIndex: '2' }}>
            {t('signUp.cityOfOperation')}
          </div>

          <ModalPickerSelector
            title={t('signUp.selectCity')}
            options={cityOptions}
            selectedValue={cityOptions.find((c) => c.value === values.city) || null}
            onChange={handleChangeCity}
            placeholder={selectedCity?.label}
            containerClassName='select-picker'
            containerStyle={{
              opacity: 1,
              cursor: 'pointer',
            }}
          />
        </div>
        {errors.city && <div className='errorLabel'>{errors.city}</div>}
      </div>
      <div className='mt-4'>
        <InputFormBorder
          name='hotelName'
          type='text'
          value={values.hotelName || ''}
          error={errors.hotelName}
          label={t('affiliateType.label.conciergeHotelName')}
          placeholder={t('affiliateType.placeholder.conciergeHotelName')}
          onChange={handleChange}
        />
      </div>

      {requiresRP && (
        <div className={`field-border-container mt-4 ${errors.rp ? 'error' : ''}`}>
          <div className='field-none-border p-0'>
            <div className='field-border-name' style={{ zIndex: '2' }}>
              {t('signUp.digitalRP')}
            </div>

            <ModalPickerSelector
              title={t('selectRP')}
              options={rps}
              selectedValue={rps.find((r) => r.value === values.rp) || null}
              onChange={handleChangeRP}
              placeholder={selectedRp?.label}
              containerClassName='select-picker'
              containerStyle={{
                opacity: 1,
                cursor: 'pointer',
              }}
            />
          </div>
          {errors.rp && <div className='errorLabel'>{errors.rp}</div>}
        </div>
      )}
    </>
  );
};

export default RPAndCitySelector;
